"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const Loading_1 = __importDefault(require("../Loading"));
const classnames_1 = __importDefault(require("classnames"));
const focus_trap_1 = require("focus-trap");
const Modal = ({ id = 'ad-hoc-modal', title, showSubmit = false, showCancel = false, showClose = true, onSubmit = () => { }, onCancel = () => { }, busy, i18n = {
    submit: 'Submit',
    cancel: 'Cancel'
}, children, className, modalClassNames = ['modal-lg', 'modal-dialog-centered'], headerClassNames = ['ps-5', 'pt-4'], bodyClassNames = ['py-2', 'px-5'], footerClassNames = ['pe-5', 'pb-4'], noScrollBody = true, showBackdrop = true, closeOnOutsideClick = true, closeOnEscape = true, trapFocus = true, trapFocusOptions, }) => {
    (0, react_1.useEffect)(() => {
        if (noScrollBody) {
            document.body.classList.add('overflow-hidden');
            return () => {
                document.body.classList.remove('overflow-hidden');
            };
        }
    }, [noScrollBody]);
    (0, react_1.useEffect)(() => {
        if (closeOnOutsideClick) {
            const listener = (e) => {
                // the .modal div is the backdrop, so if clicking on that, then close modal
                if (e.target.classList.contains('modal')) {
                    onCancel(e);
                }
            };
            document.addEventListener('click', listener);
            return () => {
                document.removeEventListener('click', listener);
            };
        }
    }, [closeOnOutsideClick, onCancel]);
    (0, react_1.useEffect)(() => {
        if (closeOnEscape) {
            const listener = (e) => {
                if (27 === e.which && !e.defaultPrevented) {
                    onCancel(e);
                }
            };
            document.addEventListener('keyup', listener);
            return () => {
                document.removeEventListener('keyup', listener);
            };
        }
    }, [closeOnEscape, onCancel]);
    const ref = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (trapFocus && ref.current) {
            const trap = (0, focus_trap_1.createFocusTrap)(ref.current, trapFocusOptions);
            try {
                trap.activate();
                return () => {
                    trap.deactivate();
                };
            }
            catch (e) {
                // Unable to trap focus.  Most likely explanation is that there are no focusable elements in the modal.
            }
        }
    }, [ref.current, trapFocus, trapFocusOptions]);
    const editorOrBody = document.querySelector('.block-editor-block-list__layout') ||
        document.body;
    return react_dom_1.default.createPortal(react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { ref: ref, className: `modal fade show ${className || ''}`, style: { display: 'block' }, id: id, "aria-labelledby": id + 'label', "aria-hidden": "false", tabIndex: -1 },
            react_1.default.createElement("div", { className: (0, classnames_1.default)('modal-dialog', modalClassNames) },
                react_1.default.createElement("div", { className: "modal-content", style: { overflow: 'visible' } },
                    react_1.default.createElement("div", { className: (0, classnames_1.default)('modal-header', headerClassNames) },
                        title && react_1.default.createElement("h5", { className: "modal-title", id: id + 'label' }, title),
                        showClose && react_1.default.createElement("button", { type: "button", className: "btn-close", onClick: onCancel, "aria-label": i18n.cancel })),
                    react_1.default.createElement("div", { className: (0, classnames_1.default)('modal-body', bodyClassNames) }, children),
                    (showCancel || showSubmit) && react_1.default.createElement("div", { className: (0, classnames_1.default)('modal-footer', footerClassNames) },
                        busy && react_1.default.createElement(Loading_1.default, { inline: true }),
                        showCancel && react_1.default.createElement("button", { type: "button", disabled: busy, className: "btn btn-secondary", onClick: onCancel }, i18n.cancel),
                        showSubmit && react_1.default.createElement("button", { type: "button", disabled: busy, className: "btn btn-primary", onClick: onSubmit }, i18n.submit))))),
        showBackdrop && react_1.default.createElement("div", { className: "modal-backdrop fade show" })), editorOrBody);
};
exports.default = Modal;
